import type {JSONNode} from '@packages/shared/types/JSONNode';

/**
 * Coerces the JSON node to an Iframe type if it has an iframe tag and the JSON
 * node type is not Iframe or DOM. The coercion is necessary to make sure that
 * iframes are rendered in a controlled way in Iframe and DOM atoms.
 * @param jsonNode
 */
export function coerceIframeElement(jsonNode: JSONNode): JSONNode {
  const hasIframeTag =
    toLowerCase(jsonNode.tag) === 'iframe' ||
    toLowerCase(jsonNode.data?.tag) === 'iframe';

  if (hasIframeTag && jsonNode.type !== 'Iframe' && jsonNode.type !== 'DOM') {
    // We coerce the type to Iframe so that we render iframes in a controlled way
    // in Iframe and DOM atoms that sanitize the data attributes.
    return {...jsonNode, type: 'Iframe'};
  }

  return jsonNode;
}

function toLowerCase(value: unknown) {
  return typeof value === 'string' ? value.toLowerCase() : '';
}
